import {
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Menu,
  MenuButton,
  MenuList,
  MenuItem
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { HeaderIcon } from "../Header.styled";
import { IoIosArrowForward } from "react-icons/io";
import { AiOutlineComment } from "react-icons/ai";
import {
  BiArrowToRight,
  BiArrowFromRight,
  BiArrowFromBottom
} from "react-icons/bi";
import { MdNotifications, MdSettings } from "react-icons/md";
import "./Styled.css";

import { NavLink } from "react-router-dom";
import { resolvePassTypeO } from "pages/Pass-Form/passTypeUtils";
import { RadioBtnRedonder } from "components/ComponentRadioButton/RadioBtnRedonder";

import { IconGeneric, IconImport, IconMenuRUD } from "styled/Icons.styled";
import { Title } from "styled/Title";

import styled from "styled-components/macro";

import { HrDividerNoMargin } from "styled/Line.styled";
import { HiDotsHorizontal } from "react-icons/hi";
import { BsCheck2All, BsDownload } from "react-icons/bs";
import environment from "constants/apiConst";
import { __Post } from "request/Petitions/__Post";
import { useSelector } from "react-redux";

const MenuItemStyled = styled(MenuItem)`
  background-color: #fff !important;
  color: #000000;

  &:hover {
    background-color: #1f7ac3 !important;
    color: #fff !important;
  }
  &:hover * {
    color: #fff !important;
  }
`;

export const Notification = ({
  isOpen,
  onClose,
  notif,
  update,
  readAll,
  onOpenConfi
}) => {
  const routeEnty = "/FormShow?FormEntry=";
  const routeEntyCorrect = "/FormCorrection?ShowEntry=";
  const routeOutput = "/FormShowExit?ExitNumber=";
  const routeOutputCorrect = "/FormCorrectionOutput?ShowOutput=";
  const routeProducts = "/product-int?movement=Productos";
  const routeThirdParty = "/third-parties";
  const optionsBalance = ["Todas", "No leídas"];
  const [All, setAll] = useState("Todas");
  const [CardNotif, setCardNotif] = useState(notif);
  const token = useSelector((state) => state.auth.dataUser.token);
  const routeUnitMeasurment = "/product-int?movement=Unidades+de+medida";
  const routeIntegrationBox = "/ShowIntegrationBox";
  const routeEntryPass = "/entry-movement?movement=Pase+de+entrada";
  const routeOutputPass = "/output-movement?movement=Pase+de+salida";
  useEffect(() => {
    if (All === "Todas") {
      setCardNotif(notif);
    } else if (All === "No leídas") {
      const noRead = notif.filter(({ is_read }) => is_read === 0);

      setCardNotif(noRead);
    }
  }, [All, notif]);

  const updateGet = (id, read) => {
    if (read === 0) {
      update(id);
    }
    onClose();
  };

  const getIconForNotif = (flag) => {
    if (flag === "export_file" || flag === "output_form_srt") return BsDownload;

    if (flag === "bulk_items_import" || flag === "entry_form_items_bulk_import") return BsDownload;

    // ingreso
    if (
      flag === "login" ||
      flag === "entry_form" ||
      flag === "entry_form_created" ||
      flag === "entry_form_updated" ||
      flag === "entry_form_changed_status" ||
      flag === "entry_form_changed_status_returned" ||
      flag === "entry_form_corrected_create" ||
      flag === "entry_form_corrected_update" ||
      flag === "entry_form_corrected_changed_status" ||
      flag === "document_approved_entry" ||
      flag === "notification_expire_form_entry" ||
      flag === "notification_expire_form_entry_30"
    ) {
      return BiArrowToRight;
      // salida
    } else if (
      flag === "output_form" ||
      flag === "output_form_update" ||
      flag === "output_form_created" ||
      flag === "output_form_changed_status" ||
      flag === "output_form_changed_status_returned" ||
      flag === "output_form_corrected" ||
      flag === "output_form_corrected_create" ||
      flag === "output_form_corrected_update" ||
      flag === "output_form_corrected_changed_status" ||
      flag === "document_approved_output" ||
      flag === "notification_expire_form_output" ||
      flag === "notification_expire_form_output_60" ||
      flag === "output_form_srt"
    ) {
      return BiArrowFromRight;
    } else if (
      flag === "entry_form_comment" ||
      flag === "output_form_comment" ||
      flag === "entry_form_comment_corrected" ||
      flag === "output_form_corrected_comment"
      // ingreso corregido
    ) {
      return AiOutlineComment;
    } else if (
      flag === "customs_clearance_changed_status" ||
      flag === "integration_certificate" ||
      flag === "integration_certificate_changed_status" ||
      flag === "integration_certificate_corrected_changed_status"
    ) {
      return BiArrowFromBottom;
    } else if (
      flag === "entry_pass" ||
      flag === "entry_pass_corrected" ||
      flag === "entry_pass_changed_status"
    ) {
      return BiArrowToRight;
    } else if (
      flag === "dispatch_pass" ||
      flag === "dispatch_pass_corrected" ||
      flag === "dispatch_pass_comment_corrected" ||
      flag === "dispatch_pass_change_status"
    ) {
      return BiArrowFromRight;
    } else {
      return MdNotifications;
    }
  };

  /** @param {string|number} docId @param {string} [passNumber] @param {''|'Dispatch'} typeO */
  const buildPassPasesRoute = (docId, passNumber, typeO) => {
    const num =
      passNumber != null && passNumber !== ""
        ? encodeURIComponent(String(passNumber))
        : "";
    const typeParam = resolvePassTypeO({ typeO });
    return `/pases?numberForm=${num}&id=${docId}&status=&typeO=${typeParam}`;
  };

  const getRouteForNotif = (flag, doc_id, form) => {
    // ingreso
    if (
      flag === "login" ||
      flag === "entry_form" ||
      flag === "entry_form_comment" ||
      flag === "entry_form_created" ||
      flag === "entry_form_updated" ||
      flag === "entry_form_changed_status" ||
      flag === "entry_form_changed_status_returned" ||
      flag === "document_approved_entry" ||
      flag === "notification_expire_form_entry" ||
      flag === "notification_expire_form_entry_30" ||
      flag === "document_finalized_entry" || 
      flag === "transfer_notification" ||
      flag === "bulk_items_import" ||
      flag === "entry_form_items_bulk_import"
    ) {
      return routeEnty + doc_id;
      // salida
    }
    if (
      flag === "output_form" ||
      flag === "output_form_update" ||
      flag === "output_form_created" ||
      flag === "output_form_changed_status" ||
      flag === "output_form_changed_status_returned" ||
      flag === "output_form_comment" ||
      flag === "document_approved_output" ||
      flag === "notification_expire_form_output" ||
      flag === "notification_expire_form_output_60" ||
      flag === "document_finalized_output" ||
      flag === "output_form_srt" ||
      flag === "output_form_kg"
    ) {
      return routeOutput + doc_id;
      // ingreso corregido
    }
    if (
      flag === "entry_form_corrected_create" ||
      flag === "entry_form_corrected_update" ||
      flag === "entry_form_corrected_changed_status" ||
      flag === "entry_form_comment_corrected"
    ) {
      return routeEntyCorrect + doc_id;
      // salida corregido
    }
    if (
      flag === "output_form_corrected" ||
      flag === "output_form_corrected_create" ||
      flag === "output_form_corrected_update" ||
      flag === "output_form_corrected_changed_status" ||
      flag === "output_form_corrected_comment" ||
      flag === "output_form_srt"
    ) {
      return routeOutputCorrect + doc_id;
    }
    if (flag === "products") {
      return routeProducts + "&searchSimple={\"valueQualified\":{\"value\":\"" + doc_id + "\"}}";
    }
    if (flag === "third_party") {
      return routeThirdParty + "?searchSimple={\"valueQualified\":{\"value\":\"" + doc_id + "\"}}";
    }
    if (flag === "unit_measurment") {
      return routeUnitMeasurment + "&searchSimple={\"valueQualified\":{\"value\":\"" + doc_id + "\"}}";
    }
    if (flag === "import_supplies_ci_items") {
      return routeIntegrationBox + "?id=" + doc_id;
    }
    if (flag === "import_entry_passes") {
      return routeEntryPass + "&searchSimple={\"valueQualified\": [{\"value\": " + doc_id + "}]}";
    }
    if (flag === "import_output_passes") {
      return routeOutputPass + "&searchSimple={\"valueQualified\": [{\"value\": " + doc_id + "}]}";
    }
    if (flag === "customs_clearance_changed_status") {
      return `/ShowCustomsClearance?Customs=${doc_id}`;
    }
    if (
      flag === "entry_pass" ||
      flag === "entry_pass_corrected" ||
      flag === "entry_pass_changed_status"
    ) {
      return buildPassPasesRoute(doc_id, form, "");
    }
    if (
      flag === "dispatch_pass" ||
      flag === "dispatch_pass_change_status"
    ) {
      return buildPassPasesRoute(doc_id, form, "Dispatch");
    }
    if (
      flag === "dispatch_pass_corrected" ||
      flag === "dispatch_pass_comment_corrected"
    ) {
      return `/DispathcCorrectionShow?Dispatch=${doc_id}&Action=Show`;
    }
    if (
      flag === "integration_certificate" ||
      flag === "integration_certificate_changed_status"
    ) {
      return `${routeIntegrationBox}?id=${doc_id}`;
    }
    if (flag === "integration_certificate_corrected_changed_status") {
      return `${routeIntegrationBox}?idCorrected=${doc_id}`;
    }
    return "/";
  };

  const handleDownload = async (doc_id, id, is_read) => {
    updateGet(id, is_read);
    const res = await __Post(environment.GET_JOB_STATUS, token, {
      job_id: doc_id
    });
    const data = res?.data?.status;
    if (data?.code === 200) {
      data?.data?.url && window.open(data?.data?.url, "_blank");
    }
  };

  const handleNavigation = (flag, id, doc_id, is_read, title, form) => {
    if (flag === "export_file") {
      return <spam onClick={() => handleDownload(doc_id, id, is_read)}>{title}</spam>;
    }
    return (
      <NavLink
        to={getRouteForNotif(flag, doc_id, form)}
        className=" exampleA"
        onClick={() => updateGet(id, is_read)}
      >
        {title}
      </NavLink>
    );
  };

  return (
    <>
      <Drawer size="xs" isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          {/* <DrawerCloseButton /> */}

          <DrawerHeader className="align-items-center">
            <div className="row">
              <div className="col-8">
                <div className="d-flex">
                  <HeaderIcon as={MdNotifications} color="#1f7ac3" />
                  <h1 className="titleNotif mt-1">Notificaciones</h1>
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <HeaderIcon
                    className="ms-5 float-end"
                    as={IoIosArrowForward}
                    onClick={onClose}
                    wd="15px"
                    color="#000"
                  />
                </div>
              </div>
            </div>
          </DrawerHeader>

          <DrawerBody>
            <div className="mb-4">
              <RadioBtnRedonder
                options={optionsBalance}
                setOnly={setAll}
                state={All}
              />

              <div className="d-flex float-end">
                <Menu>
                  <MenuButton>
                    <IconGeneric as={HiDotsHorizontal} />
                  </MenuButton>
                  <MenuList
                    borderRadius="none"
                    py={0}
                    style={{ boxSizing: "border-box" }}
                  >
                    <MenuItemStyled onClick={() => onOpenConfi()} py={3}>
                      <IconMenuRUD as={MdSettings} />
                      Configuración de notificaciones
                    </MenuItemStyled>
                    {CardNotif && CardNotif.length !== 0 && (
                      <>
                        <HrDividerNoMargin />
                        <MenuItemStyled onClick={() => readAll()} py={3}>
                          <IconMenuRUD as={BsCheck2All} />
                          Marcar todas como leídas
                        </MenuItemStyled>
                      </>
                    )}
                  </MenuList>
                </Menu>
              </div>
            </div>
            {CardNotif &&
              CardNotif.map(({ is_read, notification_push, id }) => {
                const { title, description, flag, doc_id, date_time, form } =
                  notification_push;
                return (
                  <>
                    <div
                      id={is_read === 0 && "noViewUser"}
                      className="mt-2 p-1"
                    >
                      {/* IoIosWarning */}
                      <div className="row align-items-center">
                        <div className="col-2">
                          <HeaderIcon
                            as={getIconForNotif(flag)}
                            color={is_read !== 0 ? "#BABABA" : "#1f7ac3"}
                            onClick={
                              flag === "export_file"
                                ? () => {handleDownload(doc_id, id, is_read);}
                                : null
                                
                            }
                          />
                        </div>
                        <div className="col-10">
                          <h1 className="dateNotification float-end">
                            {date_time}
                          </h1>
                          <h1 className="titleNotification mt-2">
                            {handleNavigation(flag, id, doc_id, is_read, title, form)}
                          </h1>
                          {/* {title} */}
                          <h1 className="descriptionNotification">
                            {description}
                          </h1>
                          {is_read !== 0 && (
                            <Divider className="my-2" color="#BABABA" />
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}

            {CardNotif && CardNotif.length === 0 && (
              <>
                <div
                  id="redonder"
                  className="d-flex justify-content-center centerIcon "
                >
                  <IconImport color="#fff" as={MdNotifications} />
                </div>
                <Title className="text-center">Estás al día.</Title>
                <h1 className="text-center">
                  No tienes ninguna notificación no leída aquí.
                </h1>
              </>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
